import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Accordion as AccordionLegion, Avatar, Card, DynamicIcon } from 'legion-ui';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`The accordion component is used to show or hide content. For use this components don’t forget to add import `}<inlineCode parentName="p">{`legion-ui`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Accordion } from 'legion-ui';
`}</code></pre>
    <br />
    <h2>{`Variant`}</h2>
    <p>{`Legion Have 2 varian of Accordion:`}</p>
    <h3><strong parentName="h3">{`Accordion with Left Icon`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <AccordionLegion id="accordion-one" title="Accordion with left icon" iconLeft={<DynamicIcon size="16" name="Home" mdxType="DynamicIcon" />} css={{
        marginBottom: '12px'
      }} mdxType="AccordionLegion">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
    aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
    Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
    sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
  </AccordionLegion>
    </div>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p><strong parentName="p">{`Warning:`}</strong>{` Don’t forget to import accordion from `}<inlineCode parentName="p">{`legion-ui`}</inlineCode>{`
This sample code to use accordion with Left Icon`}</p>
    </InlineNotification>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Accordion } from 'legion-ui';

<Accordion
  id="accordion-one"
  title="Accordion with left icon"
  iconLeft={<DynamicIcon size="16" name="Home" />}
  css={{ marginBottom: '12px' }}
>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
  aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
  occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
</Accordion>
`}</code></pre>
    <p>{`Default of accordion have a bottom border if you don’t want to use the bottom border then you can add property `}<inlineCode parentName="p">{`bordered={false}`}</inlineCode>{`
This code sample how to use `}<inlineCode parentName="p">{`bordered`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Accordion } from 'legion-ui';

<Accordion
  id="accordion-one"
  title="Accordion with left icon"
  iconLeft={<DynamicIcon name="Home" />}
  css={{ marginBottom: '12px' }}
  bordered={false}
>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
  aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
  occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
</Accordion>
`}</code></pre>
    <h3><strong parentName="h3">{`Accordion without icon`}</strong></h3>
    <p>{`Usage Accordion without icon`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <AccordionLegion id="accordion-two" title="Accordion without icon" mdxType="AccordionLegion">
    <Card css={{
          padding: '24px'
        }} mdxType="Card">
      <Avatar size="large" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" mdxType="Avatar" />
      <div>Accordion with custom content</div>
    </Card>
  </AccordionLegion>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { accordion } from 'legion-ui';

<Accordion id="accordion-two" title="Accordion without icon">
  <Card css={{ padding: '24px' }}>
    <Avatar size="large" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
    <div>Accordion with custom content</div>
  </Card>
</Accordion>
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bordered`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets accordion bottom border`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pass all the necessary components here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`iconLeft`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the accordion left icon`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identify accordion title to its content`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`title`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Identify accordion title to its content`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      